import React from 'react';
import PropTypes from 'prop-types';
import { CalendarList } from '../../../../common/';
import {
  StyledModal,
  StyledModalHeader,
} from '../../../../common/form/FormElements';

const EventsDetailModal = ({ visible, toggle, events, title }) => {
  return (
    <>
      {visible && (
        <StyledModal
          className="events-detail-modal"
          open={visible}
          footer={null}
          size="md"
          onCancel={() => toggle()}
        >
          <StyledModalHeader>{title} </StyledModalHeader>

          <CalendarList
            events={events}
            startAccessor={'start'}
            endAccessor={'end'}
            titleAccessor={'title'}
            url={'url'}
            onClose={toggle}
          />
        </StyledModal>
      )}
    </>
  );
};

EventsDetailModal.propTypes = {
  visible: PropTypes.bool,
  toggle: PropTypes.func,
  events: PropTypes.array,
  title: PropTypes.string,
};

export default EventsDetailModal;
